export default function () {
  this.loadTemplates()
}
